import { render, staticRenderFns } from "./Emojis.vue?vue&type=template&id=260367ea&scoped=true&"
import script from "./Emojis.vue?vue&type=script&lang=js&"
export * from "./Emojis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260367ea",
  null
  
)

export default component.exports